<template>
  <div class="ac-schedule-service ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-b gap-16">
        <button
          class="ac-close-button"
          type="button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="ac-header">
          {{ header }}
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div class="sac__font-18 med margin-bottom-12">
        {{ title }}
      </div>
      <SACButtonSelect
        :value="actionReason"
        :options="[{
          label: 'Customer Declined',
          value: 'customer declined',
          show: true,
        }, {
          label: 'Known Issue/No action',
          value: 'no action',
          show: true,
        }]"
        :onSelect="(value) => change('actionReason', value)"
        class="decline-reason-pill"
      />
      <div
        v-if="errorObj.actionReasonErr"
        class="sac__font-14 tomato med"
      >
        {{ errorObj.actionReasonErr }}
      </div>
      <div class="ac-input-container margin-top-16">
        <div class="ac-input-header">
          Notes <span class="ac-input-sub">(Optional)</span>
        </div>
        <textarea
          v-model="actionNote"
          placeholder="Leave a note here..."
          class="decline-textarea-container"
        />
        <div class="sac__font-12 med left">
          500 Character Max
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="sac__button bg-transparent"
        type="button"
        @click="toggleActionModal(false)"
      >
        <span class="decline-service-cancel-btn-txt">Cancel</span>
      </button>
      <button
        class="sac__button bg-primary margin-left-16"
        :disabled="processingAction"
        type="button"
        @click="serviceAction"
      >
        <img
          v-if="processingAction"
          class="ac-processing"
          src="@shared/assets/img/general/loading-white.svg"
          alt="processing"
        >
        <span class="decline-service-sub-btn-txt">Submit</span>
      </button>
    </div>
  </div>
</template>
<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import SACButtonSelect from '@shared/components/sac/SACButtonSelect.vue';

export default {
  name: 'DeclineService',
  components: {
    SACButtonSelect,
  },
  mixins: [serviceMixin],
  props: {
    header: String,
    title: String,
  },
  data() {
    return {
      actionReason: '',
      actionNote: '',
      errorObj: {},
    };
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    isValid() {
      const temp = {};
      if (!this.actionReason) {
        temp.actionReasonErr = 'Please select reason';
      }
      this.errorObj = { ...temp };
      return Object.keys(this.errorObj).length === 0;
    },
    async serviceAction() {
      if (this.isValid()) {
        const {
          alertNoticeId,
          jobId,
          requestId,
        } = this.actionRequest;
        const actionReq = {
          ...this.actionRequest,
          actionNote: this.actionNote,
          customerNotes: this.actionReason,
          workPerformed: this.actionNote,
        };
        if (alertNoticeId) {
          await this.$store.dispatch('updateAlertNoticeAction', actionReq);
        } else if (jobId) {
          await this.$store.dispatch('updateServiceJob', actionReq);
        } else if (requestId) {
          await this.$store.dispatch('updateServiceRequest', actionReq);
        }
        this.toggleActionModal(false);
      }
    },
  },
};
</script>
